export default __webpack_public_path__ + "static/media/rosegold.e56c076b.jpg";